import { gsap } from 'gsap';

/**
 * Play the intro animation once, on first load.
 * Always reveals the app, also when the animation is skipped or fails.
 */
export function playIntro(root) {
    const reveal = () => document.documentElement.classList.add('is-ready');

    // respect users who prefer less motion: just show the app
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        reveal();
        return;
    }

    try {
        // reveal and set the start state in the same frame, so nothing flashes
        reveal();

        const tl = gsap.timeline({ defaults: { ease: 'power2.out', clearProps: 'all' } });

        const app = root;
        const texts = root.querySelectorAll('.app__hint, .app__progress, .app__variant');
        const cells = root.querySelectorAll('.grid__item');

        tl.from(app, {
                autoAlpha: 0,
                y: 16,
                duration: 0.5,
            })
            .from(texts, {
                autoAlpha: 0,
                y: -8,
                duration: 0.5,
                stagger: 0.1,
            }, '-=0.25')
            .from(cells, {
                autoAlpha: 0,
                scale: 0.75,
                duration: 0.5,
                ease: 'back.out(2)',
                stagger: {
                    each: 0.1,
                    grid: [3, 3],
                },
            }, '-=0.5');

    } catch (error) {
        console.warn('Intro animation failed', error);
        reveal();
    }
}
